import { type InstagramBasicCredentials } from '@unipile/provider-instagram';
import { Button, Field, FieldGroup, FieldLabel, Input, LocationConfig, Spinner, useHostedAuthSession } from '@unipile/ui';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function CredentialsForm({
  onSubmit,
  isPending,
}: {
  onSubmit: (data: InstagramBasicCredentials) => void;
  isPending?: boolean;
}) {
  const { data: session } = useHostedAuthSession();

  const form = useForm<InstagramBasicCredentials>({
    defaultValues: {
      username: session?.config?.global?.login_hint || '',
      password: '',
    },
  });
  const { t } = useTranslation();

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <FieldGroup>
        <Controller
          control={form.control}
          name="username"
          rules={{ required: t('LoginScreen.form.username.required', { ns: 'instagram' }) }}
          render={({ field }) => (
            <Field>
              <FieldLabel>{t('LoginScreen.form.username.label', { ns: 'instagram' })}</FieldLabel>
              <Input placeholder={t('LoginScreen.form.username.label', { ns: 'instagram' })} {...field} />
            </Field>
          )}
        />

        <Controller
          control={form.control}
          name="password"
          rules={{ required: t('LoginScreen.form.password.required', { ns: 'instagram' }) }}
          render={({ field }) => (
            <Field>
              <FieldLabel>{t('LoginScreen.form.password.label', { ns: 'instagram' })}</FieldLabel>
              <Input type="password" placeholder="••••••••" {...field} />
            </Field>
          )}
        />
        <LocationConfig provider="instagram" />

        <Button type="submit" disabled={isPending}>
          {isPending && <Spinner />}
          {t('Common.next')}
        </Button>
      </FieldGroup>
    </form>
  );
}
